export const actionTypes = {
  POST_REPORTS_SUCCESS: 'POST_REPORTS_SUCCESS',
  POST_REPORTS_FAILURE: 'POST_REPORTS_FAILURE',
  GET_REPORTS_SUCCESS: 'GET_REPORTS_SUCCESS',
  GET_REPORTS_FAILURE: 'GET_REPORTS_FAILURE',
  GET_REPORTS_LOADER: 'GET_REPORTS_LOADER',
  SHOW_LOADER_REPORTS: 'SHOW_LOADER_REPORTS',

  SET_REPORTS_DATA: 'SET_REPORTS_DATA',

  GET_FILTER_DATA_SUCCESS: 'GET_FILTER_DATA_SUCCESS',
  GET_FILTER_DATA_LOADER: 'GET_FILTER_DATA_LOADER',
  GET_FILTER_DATA_FAILURE: 'GET_FILTER_DATA_FAILURE',
  CLEAR_FILTER_DATA: 'CLEAR_FILTER_DATA',

  SEND_REPORT_THROUGH_MAIL_SUCCESS: 'SEND_REPORT_THROUGH_MAIL_SUCCESS',
  SEND_REPORT_THROUGH_MAIL_FAILURE: 'SEND_REPORT_THROUGH_MAIL_FAILURE',
  SEND_REPORT_THROUGH_MAIL_LOADER: 'SEND_REPORT_THROUGH_MAIL_LOADER',

  EXPERTISE_SKILL_SEARCH_SUCCESS: 'EXPERTISE_SKILL_SEARCH_SUCCESS',
  EXPERTISE_SKILL_SEARCH_FAILURE: 'EXPERTISE_SKILL_SEARCH_FAILURE',
  EXPERTISE_SKILL_SEARCH_LOADER: 'EXPERTISE_SKILL_SEARCH_LOADER',
  FETCH_EXPERTISE_RESUME_SUCCESS: 'FETCH_EXPERTISE_RESUME_SUCCESS',
  FETCH_EXPERTISE_RESUME_FAILURE: 'FETCH_EXPERTISE_RESUME_FAILURE',
  EXPERTISE_RESUME_LOADER: 'EXPERTISE_RESUME_LOADER',
  CLEAR_SKILLS_SEARCH: 'CLEAR_SKILLS_SEARCH',
  IS_NO_SKILLS_CERTS: 'IS_NO_SKILLS_CERTS',
  IS_SKILLS_CERTS: 'IS_SKILLS_CERTS',
};
